import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import { memo, useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import moment from 'moment';
import { red } from '@mui/material/colors';
import { constants } from '../../../../constants';
import { blue, green, orange } from '@mui/material/colors';
import Check_refresh from 'app/main/Check_refresh';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import {useTranslation} from 'react-i18next';

function Grafica({ data, user, actions }) {
  const {t} = useTranslation('navigation');
  const [week, setweek] = useState([]);
  const [series, setSeries] = useState([]);
  const history = useHistory();
  const token = localStorage.token;
  const compacctnum = user?.company?.compacctnum;

  const [chartData, setData] = useState({
    series: [],
    options: {
      chart: {
        id: 'area-datetime',
        type: 'area',
        height: 350,
        zoom: {
          autoScaleYaxis: true,
        },
      },
      fill: {
        colors: [green[500], blue[500], orange[500], red[500]],
      },
      dataLabels: {
        enabled: false,
        colors: [green[500], blue[500], orange[500], red[500]],
      },
      stroke: {
        curve: 'smooth',
        colors: [green[500], blue[500], orange[500], red[500]],
      },
      xaxis: {
        type: 'datetime',
        categories: week,
      },
      tooltip: {
        x: {
          format: 'MMM dd yyyy',
        },
      },
      legend: {
        onItemClick: {
          toggleDataSeries: true,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
        labels: {
          useSeriesColosr: true,
        },
      },
      markers: {
        colors: [green[500], blue[500], orange[500], red[500]],
      },
    },
  });

  const getGraphicData = async () => {
    if (data) {
      const result = await Check_refresh();
      if (!result) {
        return history.replace('/login');
      }
      try {
        const _getJobById = await fetch(
          `${constants.URLLOCAL}/jobs/ticket-gli/${data}/${compacctnum}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              token: `${token}`,
            },
          }
        );
        const _jsonGetById = await _getJobById.json();

        if (_jsonGetById.msg) {
          return;
        }
        let _materialCr = [];
        let _ticketCr = [];
        let _waitTimeCr = [];
        let _ticketComm = [];
        let material_cr = 0;
        let ticket_cr = 0;
        let wait_cr = 0;
        let employee_ticket_cost = 0;

        _jsonGetById.forEach((element) => {
          material_cr = element.material_cr
            ? Number(element.material_cr.replace(/[^0-9\.]/g, ''))
            : 0;
          ticket_cr = element.ticket_cr ? Number(element.ticket_cr.replace(/[^0-9\.]/g, '')) : 0;
          wait_cr = element.wait_cr ? Number(element.wait_cr.replace(/[^0-9\.]/g, '')) : 0;
          employee_ticket_cost = element.employee_ticket_cost
            ? Number(element.employee_ticket_cost.replace(/[^0-9\.]/g, ''))
            : 0;

          week.push(moment(element.date_created).format('MM-DD-YYYY'));
          _materialCr.push(material_cr ? material_cr : 0);
          _ticketCr.push(ticket_cr ? ticket_cr : 0);
          _waitTimeCr.push(wait_cr ? wait_cr : 0);
          _ticketComm.push(employee_ticket_cost ? employee_ticket_cost : 0);
        });
        setweek(week);

        setSeries([
          {
            name: t('HAULING_SALES'),
            data: _ticketCr,
          },
          {
            name: t('MATERIAL_SALES'),
            data: _materialCr,
          },
          {
            name: t('WAIT_TIME_CHARGES'),
            data: _waitTimeCr,
          },
          {
            name: t('EMPLOYEE_COMMISSION'),
            data: _ticketComm,
          },
        ]);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    getGraphicData();
  }, []);

  useEffect(() => {}, [series, week]);

  const chart = (
    <div
      className="py-0 jobgraph"
      style={actions ? { width: '100%', marginLeft: 0 } : undefined}
    >
      <ReactApexChart
        options={chartData.options}
        series={series}
        type="area"
        height={'300px'}
      />
    </div>
  );

  return actions ? (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 25%) minmax(0, 75%)',
        columnGap: 16,
        alignItems: 'start',
      }}
    >
      <AppBar position="static" elevation={0} style={{ gridColumn: 2, gridRow: 1 }}>
        <div className="flex flex-row ">
          <Typography className="text-32 font-semibold leading-none" color="inherit">
            {chartData.today}
          </Typography>
        </div>
      </AppBar>
      <div className="job-chart-side" style={{ gridColumn: 1, gridRow: 2, marginTop: 20, minWidth: 0 }}>
        {actions}
      </div>
      <div style={{ gridColumn: 2, gridRow: 2, minWidth: 0 }}>{chart}</div>
    </div>
  ) : (
    <>
      <AppBar position="static" elevation={0}>
        <div className="flex flex-row ">
          <Typography className="text-32 font-semibold leading-none" color="inherit">
            {chartData.today}
          </Typography>
        </div>
      </AppBar>
      {chart}
    </>
  );
}
// injectReducer(AuthReducer)

// injectReducer(AuthReducer)
const mapStateToProps = (state) => {
  return {
    user: state.loadz_auth?.AuthReducer?.user,
  };
};

const mapDispatchToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(memo(Grafica));
